import focusableSelectors from 'focusable-selectors';

//import './helpers/legacy/jquery';
import './vendor/sp-display-condition';
import {translate} from './helpers/i18n';

/** @typedef {{component: string, elementIdBase: string, submitOnChange?: boolean}|null} BraunschweigMapsightSourceSearchControllerData */

SP.lang.Class.define(
	'SP.sitekit.search.BraunschweigMapsightSourceSearchController',
	{
		/** @property {Element} _el */
		_el: null,
		/** @property {Element} _form */
		_form: null,
		/** @property {BraunschweigMapsightSourceSearchControllerData} _data */
		_data: null,
		_searchDelay: 200,

		/** @var {Element} _toggleButton */
		_toggleButton: null,
		/** @var {Element} _toggleButtonLabel */
		_toggleButtonLabel: null,
		_expanded: false,

		_updateExpanded: function () {
			// update toggle button
			this._toggleButtonLabel.innerHTML = this._expanded
				? translate(
						'SP.sitekit.search.BraunschweigMapsightSourceSearchController.closeFilter'
				  )
				: translate(
						'SP.sitekit.search.BraunschweigMapsightSourceSearchController.openFilter'
				  );
			this._toggleButton.setAttribute(
				'aria-expanded',
				this._expanded ? 'true' : 'false'
			);

			// update container
			this._el.classList[this._expanded ? 'add' : 'remove'](
				'bs-mapsight-source-search--expanded'
			);

			// update form
			this._form.classList[this._expanded ? 'add' : 'remove'](
				'bs-mapsight-source-search__form--expanded'
			);
		},

		/**
		 * @param {Element} el container element
		 * @param {BraunschweigMapsightSourceSearchControllerData} data data for the search controller
		 */
		init: function (el, data) {
			this._el = el;
			this._data = data;
			this._form = el.querySelector('form');

			this._el.classList.add('bs-mapsight-source-search');
			this._form.classList.add('bs-mapsight-source-search__form');

			this._toggleButtonLabel = document.createElement('span');
			this._toggleButtonLabel.className =
				'bs-mapsight-source-search__toggle-button__label';

			this._toggleButton = document.createElement('button');
			this._toggleButton.className =
				'bs-mapsight-source-search__toggle-button';
			this._toggleButton.type = 'button';
			this._toggleButton.innerHTML = `
			<svg xmlns="http://www.w3.org/2000/svg"
				class="bs-icon bs-mapsight-source-search__toggle-button__icon"
				aria-hidden="true" role="img"
				width="20" height="20"
				viewBox="0 0 20 20"
			>
				<path d="M10 13L1 1h18l-9 12z" />
				<path d="M12 9H8v8l4 2V9z" />
			</svg>
		`;
			this._toggleButton.prepend(this._toggleButtonLabel);
			this._toggleButton.setAttribute('aria-controls', this._form.id);
			this._toggleButton.addEventListener('click', () => {
				this._expanded = !this._expanded;
				this._updateExpanded();

				if (this._expanded) {
					const firstFocusable = this._form.querySelector(
						focusableSelectors.join(',')
					);
					if (firstFocusable) {
						firstFocusable.focus();
					}
				}
			});
			this._updateExpanded();
			this._el.prepend(this._toggleButton);

			this._form.addEventListener(
				'change',
				SP.lang.Function.debounce((e) => {
					this._processChangeEvent(e);
				}, this._searchDelay)
			);

			this._form.addEventListener('submit', (e) => {
				e.stopPropagation();
				e.preventDefault();
				this._storeState();
				this._reloadResultSets();
			});

			// bei History-Back die Seite neu laden
			window.addEventListener('popstate', (_e) => {
				location.reload();
			});
		},

		_processChangeEvent: function (e) {
			// ignore date picker
			if (!e.target.type || e.target.type.toLowerCase() === 'date') {
				return;
			}

			const categorySelect = SP.dom.ElementStream.create(e.target)
				.parent('[data-sp-form-search-categoryselect]')
				.get();
			this._reloadAllCategorySelect(categorySelect);
			this._reloadDateComposition();

			if (this._data.submitOnChange === true) {
				this._reloadResultSets();
				this._storeState();
			}
		},

		_reloadDateComposition: function () {
			const dateComp = this._el.querySelector(
				'[data-sp-dateselectorcomposition]'
			);
			if (!dateComp || !dateComp.id) {
				return;
			}

			if (!this._form) {
				return;
			}

			const formData = new FormData(this._form);
			formData.append('sp:out', 'htmlFragment');
			formData.append('component', this._data.component);
			formData.append('formFragment', dateComp.id);
			formData.append('action', 'submit');
			try {
				SP.net.http.Client.fetch(document.location.pathname, {
					method: 'POST',
					body: formData,
				}).then((xhr, response) => {
					SP.dom.Element.replace(dateComp, response);
				});
			} catch (e) {
				console.error(e);
			}
		},

		_storeState: function () {
			// FormData -> URLSearchParams is not type safe https://github.com/microsoft/TypeScript/issues/30584
			// noinspection JSCheckFunctionSignatures
			const queryString = new URLSearchParams(new FormData(this._form));
			queryString.append('action', 'submit');
			history.pushState(
				null,
				null,
				`${window.location.pathname}?${queryString}`
			);
		},

		_categoryChanged: function (container, select) {
			this._reloadCategorySelect(container, select);
			this._reloadResultSets();
		},

		_reloadAllCategorySelect: function (focusSelect) {
			const categorySelections = this._el.querySelectorAll(
				'[data-sp-form-search-categoryselect]'
			);
			SP.lang.Array.each(categorySelections, (i, categorySelect) => {
				this._reloadCategorySelect(categorySelect, focusSelect);
			});
		},

		_reloadCategorySelect: function (container, select) {
			let resetFocus = true;
			if (!SP.isDefined(select) || select === null) {
				select = container.querySelector('select');
				resetFocus = false;
			}

			const containerData = JSON.parse(
				container.getAttribute('data-sp-form-search-categoryselect')
			);
			if (!this._form) {
				return;
			}

			const formData = new FormData(this._form);
			formData.append('sp:out', 'htmlFragment');
			formData.append('component', this._data.component);
			formData.append('formFragment', containerData.id);
			formData.append('action', 'submit');

			SP.net.http.Client.fetch(document.location.pathname, {
				method: 'POST',
				body: formData,
			}).then((xhr, response) => {
				const containerId = container.getAttribute('id');
				const selectId = select.getAttribute('id');

				SP.dom.Element.replace(container, response);

				const newContainer = parent.querySelector('#' + containerId);
				const newSelect = newContainer.querySelector('#' + selectId);
				if (resetFocus) {
					newSelect.focus();
				}
			});
		},

		_reloadResultSets: function () {
			const formData = new FormData(this._form);
			formData.append('sp:out', 'braunschweig.geoJSON');
			formData.append('processComponents', this._data.component);
			formData.append('component', this._data.component + '-resultSets');
			formData.append('action', 'submit');

			SP.net.http.Client.fetch(document.location.pathname, {
				method: 'POST',
				body: formData,
			}).then((xhr, response) => {
				window.mapsightUpdateOwnFeatureData(JSON.parse(response));
			});
		},
	}
);
